<div class="proposal-container" [formGroup]="proposalForm">
    <div>
        <label class="horizontal-padding">
            {{'PROPERTIES_PROPOSAL_LABEL' | translate}}
        </label>
    </div>
    <div class="row">
        <div class="col-sm-6 horizontal-padding">
            <fieldset>
                <legend>
                    {{'PROPERTIES_PROPOSAL_PROJECT_PRICING' | translate}}
                </legend>
                <mat-radio-group formControlName="projectPricingOption" (change)="onPricingOptionChange()">
                    <div class="row">
                        <div class="row col-sm-6 flex-column horizontal-padding">
                            <mat-radio-button color="primary" [value]="pricingSummaryType.SellPriceOnly">
                                {{'PROPERTIES_PROPOSAL_SELL_PRICE_ONLY' | translate}}
                            </mat-radio-button>
                            <mat-radio-button color="primary" [value]="pricingSummaryType.PricingBreakout">
                                {{'PROPERTIES_PROPOSAL_PRICING_BREAKOUT' | translate}}
                            </mat-radio-button>
                        </div>
                        <div class="col-sm-6 horizontal-padding">
                            <mat-radio-button color="primary" [value]="pricingSummaryType.None">
                                {{'PROPERTIES_PROPOSAL_NONE' | translate}}
                            </mat-radio-button>
                        </div>
                    </div>
                </mat-radio-group>
            </fieldset>
        </div>
        <div class="col-sm-6 horizontal-padding">
            <fieldset>
                <legend>
                    {{'PROPERTIES_PROPOSAL_AREA_PRICING' | translate}}
                </legend>
                <mat-radio-group formControlName="areaPricingOption" (change)="onPricingOptionChange()">
                    <div class="row">
                        <div class="row col-sm-6 flex-column horizontal-padding">
                            <mat-radio-button color="primary" [value]="areaSummaryType.SellPriceOnly"> 
                                {{'PROPERTIES_PROPOSAL_SELL_PRICE_ONLY' | translate}}
                            </mat-radio-button>
                            <mat-radio-button color="primary" [value]="areaSummaryType.PricingBreakout">
                                {{'PROPERTIES_PROPOSAL_PRICING_BREAKOUT' | translate}}
                            </mat-radio-button>
                        </div>
                        <div class="col-sm-6 horizontal-padding">
                            <mat-radio-button color="primary" [value]="areaSummaryType.None">
                                {{'PROPERTIES_PROPOSAL_NONE' | translate}}
                            </mat-radio-button>
                        </div>
                    </div>
                </mat-radio-group>
            </fieldset>
        </div>
    </div>
    <fieldset>
        <legend>
            {{'PROPERTIES_PROPOSAL_PRICING_BREAKOUT' | translate}}
        </legend>
        <fieldset>
            <legend>
                {{'PROPERTIES_PROPOSAL_MATERIAL' | translate}}
            </legend>
            <div class="row align-items-center">
                <div class="col-sm-4 horizontal-padding">
                    <mat-form-field appearance="outline" class="full-width col-sm-9">
                        <mat-select formControlName="materialDropdownOption"
                            (selectionChange)="onMaterialDropdownChange()">
                            @for (element of materialDropDownList; track element.id) {
                              <mat-option [value]="element.id">
                                {{element.description}}
                            </mat-option>  
                            }
                            
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="row col-sm-8 align-items-center horizontal-padding">       
                    <label class="row col-sm-2 justify-content-end align-items-center horizontal-padding">
                        {{'PROPERTIES_PROPOSAL_INCLUDE' | translate}}:
                    </label>
                    <div class="col-sm-10 horizontal-padding">
                        <div class="row">
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="sAndH"
                                (change)="onMaterialIncludeCheckboxChange()">
                                {{'PROPERTIES_PROPOSAL_S_AND_H'| translate}}
                            </mat-checkbox>
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="warranty"
                                (change)="onMaterialIncludeCheckboxChange()">
                                {{'PROPERTIES_PROPOSAL_WARRANTY' | translate}}
                            </mat-checkbox>
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="useTax"
                                (change)="onMaterialIncludeCheckboxChange()">
                                {{'PROPERTIES_PROPOSAL_USE_TAX' | translate}}
                            </mat-checkbox>
                        </div>
                    </div>   
                </div>
            </div>
        </fieldset>

        <fieldset>
            <legend>
                {{'PROPERTIES_LABOR_RATES_LABOR' | translate}}
            </legend>
            <div class="row">
                <div class="col-sm-4 horizontal-padding">
                    <mat-form-field appearance="outline" class="full-width col-sm-9">
                        <mat-select formControlName="laborDropdownOption" (selectionChange)="onLaborDropdownChange()">
                            @for(element of laborDropDownList; track element.id) {
                                <mat-option [value]="element.id">
                                    {{element.description}}
                                </mat-option>
                            }
                        </mat-select>  
                    </mat-form-field>
                </div>
                <div class="row col-sm-8 align-items-baseline horizontal-padding">
                    <label class="row col-sm-2 justify-content-end align-items-center horizontal-padding">
                        {{'PROPERTIES_PROPOSAL_DISPLAY' | translate}}:
                    </label>

                    <div class="col-sm-10 horizontal-padding">
                        <div class="row">
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="pm">
                                {{'PM' | translate}}
                            </mat-checkbox>
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="eng">
                                {{'ENG' | translate}}
                            </mat-checkbox>
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="ceng">
                                {{'CENG' | translate}}
                            </mat-checkbox>
                        </div>
                        <div class="row">
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="eeng">
                                {{'EENG' | translate}}
                            </mat-checkbox>
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="leng">
                                {{'LENG' | translate}}
                            </mat-checkbox>
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="neng">
                                {{'NENG' | translate}}
                            </mat-checkbox>
                        </div>
                        <div class="row">
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="qeng">
                                {{'QENG' | translate}}
                            </mat-checkbox>
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="grap">
                                {{'GRAP' | translate}}
                            </mat-checkbox>
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="prog">
                                {{'PROG' | translate}}
                            </mat-checkbox>
                        </div>
                        <div class="row">
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="spec">
                                {{'SPEC' | translate}}
                            </mat-checkbox>
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="dds">
                                {{'DDS' | translate}}
                            </mat-checkbox>
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="mech">
                                {{'MECH' | translate}}
                            </mat-checkbox>
                        </div>
                        <div class="row">
                            <mat-checkbox color="primary" class="col-sm-4" formControlName="elec">
                                {{'ELEC' | translate}}
                            </mat-checkbox>
                        </div>
                    </div>     
                </div>
            </div>
        </fieldset>

        <fieldset>
            <legend>
                {{'PROPERTIES_PROPOSAL_OTHER' | translate}}
            </legend>
            <div class="row align-items-center">
                <div class="col-sm-5 horizontal-padding">
                    <label class="col-sm-4">
                        {{'PROPERTIES_PROPOSAL_SUBCONTRACTORS' | translate}}
                    </label>
                    <mat-form-field appearance="outline" class="full-width col-sm-7">
                        <mat-select formControlName="subcontractorsDropdownOption">
                            @for(element of subcontractorsDropDownList; track element.id) {
                                <mat-option [value]="element.id">
                                    {{element.description}}
                                </mat-option>
                            }
                            
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="row col-sm-7 align-items-center horizontal-padding">
                    <div class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-4"></div>
                            <div class="col-sm-4 position-relative other-align-middle-columns">
                                <mat-checkbox color="primary" formControlName="otherWarranty">
                                    {{'PROPERTIES_PROPOSAL_WARRANTY' | translate}}
                                </mat-checkbox>
                            </div>
                            <div class="col-sm-4 position-relative other-align-end-columns">
                                <mat-checkbox color="primary" formControlName="otherSAndH">
                                    {{'PROPERTIES_PROPOSAL_S_AND_H' | translate}}
                                </mat-checkbox>
                            </div>
                        </div>
                        
                    </div>
                    
                </div>                
            </div>
            <div class="row align-items-center">
                <div class="col-sm-5 align-items-center">
                    <label class="col-sm-4">
                        {{'PROPERTIES_PROPOSAL_MISCELLANEOUS' | translate}}
                    </label>
                    <mat-form-field appearance="outline" class="full-width col-sm-7">
                        <mat-select formControlName="miscellaneousDropdownOption">
                            
                            @for(element of miscellaneousDropDownList; track element.id) {
                                <mat-option [value]="element.id">
                                    {{element.description}}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="row col-sm-7 align-items-center horizontal-padding">
                    <div class="col-sm-12">
                        <div class="row">
                             <div class="col-sm-4"></div>
                            <div class="col-sm-4 position-relative other-align-middle-columns">
                                <mat-checkbox color="primary" formControlName="tax">
                                    {{'PROPERTIES_PROPOSAL_TAX' | translate}}
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-sm-5 align-items-center horizontal-padding">
                    <label class="col-sm-4">
                        {{'PROPERTIES_PROPOSAL_TRAVEL' | translate}}
                    </label>
                    <mat-form-field appearance="outline" class="full-width col-sm-7">
                        <mat-select formControlName="travelDropdownOption">
                            @for(element of travelDropDownList; track element.id) {
                                <mat-option [value]="element.id">
                                    {{element.description}}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="row col-sm-7 align-items-center horizontal-padding">
                    <div class="col-sm-12">
                        <div class="row">
                             <div class="col-sm-4"></div>
                            <div class="col-sm-8 position-relative other-align-middle-columns">
                                <mat-checkbox color="primary"
                                    formControlName="includeExternalNotes">
                                    {{'PROPERTIES_PROPOSAL_INCLUDE_EXTERNAL_NOTES' | translate}}
                                </mat-checkbox>
                            </div>
                        </div>
            
                    </div>
                </div>
            </div>
        </fieldset>
        <div class="row col-sm-11 m-0 align-items-center">
            <div class="col-sm-4 p-0">
                <mat-checkbox color="primary" class="" formControlName="showAllUnselectedPricing"
                    (change)="onShowAllUnselectedPricingChange()">
                    {{'PROPERTIES_PROPOSAL_SHOW_ALL_UNSELECTED_PRICING' | translate}}:
                </mat-checkbox>
            </div>
            <div class="col-sm-4 p-0">
               <mat-form-field appearance="outline" class="full-width col-sm-10">
                    <mat-select formControlName="showAllUnselectedPricingDropdownOption"
                        (selectionChange)="onShowAllUnselectedPricingDropdownChange()">
                        @for(element of priceUnderCategoriesDropDownList; track element.id) {
                            <mat-option [value]="element.id">
                                {{element.description}}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </fieldset>
    <fieldset>
        <legend>
            {{'PROPERTIES_PROPOSAL_MATERIAL_LIST' | translate}}
        </legend>
        <div class="row align-items-center m-0">
            <div class="col-sm-3 p-0">
                <mat-form-field appearance="outline" class="full-width col-sm-11">
                    <mat-select formControlName="materialListOption" (selectionChange)="updateMaterialListState()">
                        @for(element of materialListDropDownList; track element.id) {
                            <mat-option [value]="element.id">
                                {{element.description}}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="row col-sm-5 horizontal-padding align-items-center">
                <label class="col-sm-3 horizontal-padding text-end">        
                    {{'PROPERTIES_PROPOSAL_IDENTIFIER' | translate}}:
                </label>
                <mat-form-field appearance="outline" class="full-width col-sm-7 p-0 position-relative material-list-align-field-top"> 
                    <mat-select formControlName="materialListIdentifier">
                        @for(element of identifierDropDownList; track element.id) {
                             <mat-option [value]="element.id">
                                {{element.description}}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="row col-sm-3 flex-column align-items-center material-list-align-checkboxes">
                <mat-checkbox color="primary" formControlName="sellPrice">{{'PROPERTIES_PROPOSAL_SELL_PRICE' |
                    translate}}</mat-checkbox>
                <mat-checkbox color="primary" formControlName="genericName">{{'PROPERTIES_PROPOSAL_GENERIC_NAME' |
                    translate}}</mat-checkbox>
            </div>
        </div>
    </fieldset>
    <div class="row col-sm-11 horizontal-padding">
        <button mat-raised-button color="primary" class="col-sm-4 proposals-button-styles"
            [disabled]="isReadOnly"
            (click)="optionalPageSelection()">
            {{'PROPERTIES_PROPOSAL_OPTIONAL_PAGE_SELECTION' | translate}}
        </button>
        <button mat-raised-button color="primary" class="col-sm-4 proposals-button-styles"
            [disabled]="isReadOnly"
            (click)="advancedOptions()">
            {{'PROPERTIES_PROPOSAL_ADVANCED_OPTIONS' | translate}}
        </button>
    </div>
</div>